import { LogoutView } from "@/components.auth/logout";
export const Logout = {
	path:"/auth/logout",
	name:"Logout",
	component:LogoutView,
	meta:{
		title:"Log Out",
		public:false
	}
};